<template>
  <div class="col-lg-3 col-xl-2 col-xs-12">
    
    <b-button
      variant="dark"
      class="btn-block"
    >
      Tasks
    </b-button>
    
    <div class="mb mt">
      <div v-for="button in mainButtons" :key="button.id">
        <router-link :to="{ path: button.to, props: { filter: button.filter }}" tag="span" >
        <b-button 
          :class="{ button: true, buttonActive: button.id === activeButtonId }"
          :key="button.id"
          variant="transparent"
        >
          {{button.title}}
          <b-badge v-if="button.notifications" :variant="button.label || 'default'"  pill>
            {{button.notifications}}
          </b-badge>
        </b-button>
        </router-link>
        </div>
    </div>
    
    <div>
      <h6>Follow-ups</h6>
      <div v-for="button in quickViewButtons" :key="button.id">
        <router-link :to="{ path: button.to, props: { filter: button.filter }}" tag="span" >
          <b-button
            :class="{ button: true, buttonActive: button.id === activeButtonId }"
            :key="button.id"
            variant="transparent"
          >
            {{button.title}}
            <b-badge v-if="button.notifications" :variant="button.label || 'default'"  pill>
              {{button.notifications}}
            </b-badge>
            <!-- <i :class="`fa fa-circle text-${button.colour}`" /> -->
          </b-button>
          </router-link>
        </div>
    </div>
  
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'; //eslint-disable-line
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Filters',
  props: ['filter', 'passedTasks'],
  data() {
    return {
      activeButtonId: 0,
    };
  },

  methods: {
    /*
    handleButtonClick(id, filterCond, to) {
      const { filter, tasks } = this;
      Vue.set(this, 'activeButtonId', id);
      //openTask(null);
      //filter(filterCond);
    },
    */
  },

  computed: {
    ...mapGetters('tasks', ['yourTasks', 'overdueRecallTasks']),
    /*
    ...mapState({
        tasks: state => state.tasks.tasks,
    }),
    */

    mainButtons() {
      let b =
        [
          //{ id: 0, title: 'Your Tasks', notifications: this.yourTasks.length, filter: 'YOUR_TASKS', to: '/app/tasks/YourTasks'},
          { id: 0, title: 'Your Tasks', notifications: 2, filter: 'YOUR_TASKS', to: '/app/tasks/YourTasks'},
          { id: 1, title: 'Daily Routine Tasks', filter: 'DAILY_ROUTINE', to: '/app/tasks/DailyRoutineTasks' },
          { id: 2, title: 'Missed Phone Calls', filter: 'MISSED_CALL', to: '/app/tasks/MissedCalls' },
          { id: 3, title: 'Monthly Routine Tasks', label: 'danger', filter: 'MONTHLY_ROUTINE', to: '/app/tasks/MonthlyRoutineTasks'}
        ];
        return b;
    },

    quickViewButtons() {
      let q =
      [
        { id: 4, title: 'Broken Appointments', colour: 'danger', filter: 'BROKEN_APPOINTMENTS', to: '/app/tasks/BrokenAppointments' },        
        { id: 5, title: 'Overdue Recall', notifications: 2, label: 'danger', filter: 'OVERDUE_RECALL', to: '/app/tasks/OverdueRecall' },
        { id: 6, title: 'Unscheduled Treatment', colour: 'white', filter: 'UNSCHEDULED_TREATMENT', to: '/app/tasks/UnscheduledTreatment' },
        { id: 7, title: 'Post-Operative Phone Calls', colour: '', filter: 'POST_OPERATIVE_PHONE_CALLS', to: '/app/tasks/PostOpPhoneCalls' },
        { id: 8, title: 'Unpaid Claims', colour: '', filter: 'UNPAID_CLAIMS', to: '/app/tasks/UnpaidClaims' }
      ];
      return q;
    }
  }
};
</script>

<style src="./Filters.scss" lang="scss" scoped />
